import { Alert, FormGroup, Radio, RadioGroup } from '@ksyos/design-system';
import type { InputComponentsMap } from '@frontend/formEngine/editForm/editForm.types';
import { DiaryTypes } from '@common/enums';
import {
    type HolterDiaryUploadData,
    holterDiaryUploadSections,
} from '@common/validation/customControls/cardiology/holter/holterDiaryUploadSchemas';
import { EditForm } from '@frontend/formEngine/editForm/EditForm';
import { getValidationErrorTranslation } from '@frontend/utils';
import { useProcessActivityEditContext } from '@frontend/utils/hooks/useProcessActivityContext';
import { HolterDiaryUploadButton } from './HolterDiaryUploadButton';

export function HolterDiaryUploadEdit(): JSX.Element {
    const { data, errors, onChange } = useProcessActivityEditContext<HolterDiaryUploadData>();

    return (
        <>
            <Alert appearance="warning">
                Het dagboek ontbreekt. De analyse en beoordeling van het onderzoek start zodra deze is toegevoegd.
            </Alert>
            <EditForm
                inputComponents={getInputComponents()}
                sections={holterDiaryUploadSections}
            />
            {data.error && (
                <Alert
                    appearance="warning"
                    hasIcon={true}
                >
                    Het dagboekje kon niet worden geüpload. Probeer het nog een keer. Lukt het niet? Neem dan contact op
                    met de Ksyos Servicedesk.
                </Alert>
            )}
            <HolterDiaryUploadButton />
        </>
    );

    function getInputComponents(): InputComponentsMap<keyof HolterDiaryUploadData> {
        const map: InputComponentsMap<keyof HolterDiaryUploadData> = new Map();

        map.set(
            'diaryType',
            <FormGroup
                isRequired={true}
                label="Dagboek beschikbaar"
            >
                <RadioGroup
                    error={getValidationErrorTranslation(errors.get('diaryType'))}
                    layout="row"
                    name="diaryType"
                    onChange={(e) =>
                        onChange({ diaryType: e.target.value as DiaryTypes, error: null }, ['diaryType', 'assets'])
                    }
                    value={data.diaryType}
                >
                    <Radio
                        label="Ja"
                        value={DiaryTypes.paperUpload}
                    />
                    <Radio
                        label="Nee"
                        value={DiaryTypes.none}
                    />
                </RadioGroup>
            </FormGroup>
        );

        return map;
    }
}
